import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato llega la guía?',
  a: 'En PDF digital, descarga inmediata. Funciona en celular, tablet, computadora o puedes imprimirla.'
}, {
  q: '¿Cuándo recibo mi guía?',
  a: 'INMEDIATAMENTE después del pago. Recibes el enlace de descarga al instante en tu email.'
}, {
  q: '¿Es información médica confiable?',
  a: 'Sí. Basada en guías de OMS y CDC. Siempre recomendamos complementar con tu médico.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía total. Te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Funciona para cualquier tipo de píldora?',
  a: 'Sí. Cubre píldoras combinadas y minipíldoras con información específica para cada tipo.'
}, {
  q: '¿Puedo imprimirla?',
  a: 'Sí, está diseñada para verse perfecta impresa o en pantalla.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-32">
      <div className="text-center mb-12" data-id="element-33">
        <h2 className="text-3xl font-heading font-bold text-brand-dark" data-id="element-34">
          Preguntas frecuentes antes de comprar:
        </h2>
      </div>

      <div className="space-y-4" data-id="element-35">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white rounded-[16px] shadow-sm border border-brand-cardPink/50 overflow-hidden" data-id="element-36">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-37">
              <span className="font-bold text-brand-dark pr-4 flex items-center gap-2" data-id="element-38">
                <span className="text-brand-primary" data-id="element-39">❓</span> {faq.q}
              </span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-40">
                <ChevronDown className="w-5 h-5 text-brand-secondary" data-id="element-41" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-42">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-43">
                  <div className="px-6 pb-5 text-brand-secondary flex items-start gap-2 border-t border-gray-50 pt-4" data-id="element-44">
                    <span className="text-brand-success shrink-0" data-id="element-45">✅</span>
                    <p data-id="element-46">{faq.a}</p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}